import React from "react";
import { useLocation } from "react-router-dom";

export const Header = () => {
  const location = useLocation();
  const isActive = (path) => (location.pathname === path ? "active" : "");

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "Products", path: "/products" },
    { label: "About us", path: "/aboutus" },
    { label: "Contact Us", path: "/contactus" },
  ];

  return (
    <header id="masthead" className="header prt-header-style-01">
      <div id="site-header-menu" className="site-header-menu">
        <div className="site-header-menu-inner prt-stickable-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="site-navigation d-flex flex-row align-items-center justify-content-between">
                  {/* Logo Section */}
                  <div className="site-branding">
                    <a
                      className="home-link"
                      href="/"
                      title="DigitalSignage"
                      rel="home"
                    >
                      <img
                        id="logo-img"
                        className="img-fluid auto_size digital_signage_logo"
                        src="./images/logos/digital_signage_logo.png"
                        alt="Digital Signage Company Mumbai"
                      />
                      <img
                        id="mobile-logo-img"
                        className="img-fluid auto_size mobile_logo"
                        src="./images/logos/digital_signage_logo_mobile.png"
                        alt="Digital Signage Company Mumbai Mobile Logo"
                      />
                    </a>
                  </div>

                  {/* Mobile Contact Number */}
                  <a href="tel:91 91678 60213" className="mobile-number">
                    +91 91678 60213
                  </a>

                  {/* Navigation */}
                  <div className="d-flex flex-row">
                    {/* Menu Toggle (Mobile) */}
                    <div className="btn-show-menu-mobile menubar menubar--squeeze">
                      <span className="menubar-box">
                        <span className="menubar-inner"></span>
                      </span>
                    </div>

                    {/* Menu Items */}
                    <nav className="main-menu menu-mobile" id="menu">
                      <ul className="menu">
                        {navLinks.map(({ label, path }) => (
                          <li
                            key={path}
                            className={`nav-item mega-menu-item ${isActive(path)}`}
                          >
                            <a href={path}>{label}</a>
                          </li>
                        ))}
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
